import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 32"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#fff\" d=\"M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z\"></path><path stroke=\"#EBEBEB\" d=\"M.5 4A3.5 3.5 0 0 1 4 .5h40A3.5 3.5 0 0 1 47.5 4v24a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 28z\"></path><path fill=\"#FF5F00\" d=\"M28.404 9.429H21.09V22.57h7.314z\"></path><path fill=\"#EB001B\" d=\"M21.555 16a8.344 8.344 0 0 1 3.192-6.571 8.358 8.358 0 1 0 0 13.142A8.344 8.344 0 0 1 21.555 16\"></path><path fill=\"#F79E1B\" d=\"M38.27 16a8.358 8.358 0 0 1-13.523 6.571 8.36 8.36 0 0 0 0-13.142 8.357 8.357 0 0 1 13.523 6.57Zm-.798 5.18v-.27h.109v-.055h-.276v.055h.108v.27zm.537 0v-.325h-.085l-.097.223-.098-.223h-.084v.324h.06v-.244l.09.21h.063l.091-.211v.245z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }